import { AiOutlineDownload } from 'react-icons/ai';
import { BsPencilSquare } from "react-icons/bs";
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Hta = () => {
    
    return ( 
        <div className="section">
            <div className="container mt-6" id="hta">
                <div className="topic-cont mb-5">
                    <span className="is-size-6-touch is-size-5-desktop grey-text text-lighten-4">How to Apply</span>
                </div>
                <div className="title mt-5 mb-3 grey-text text-darken-3 is-size-4">Physical Application</div>
                <div className="application-cont">
                    <div className="mb-3">
                        <p className="grey-text text-darken-2">There are various entry requirements for all the courses we offer. If you feel you meet the requirements of your courses of choice please feel free to visit our campus to collect the aplication form to start your application process.</p>
                        <h6 className="has-text-weight-bold">Process</h6>
                        <ol className="ml-4">
                            <li className="my-2">Collect Application Form</li>
                            <li className="my-2">Fill out the Form</li>
                            <li className="my-2">Submit your Form and bring the required documents</li>
                        </ol>
                    </div>
                    <div className="reqs">
                        <h6 className="has-text-weight-bold mt-1">Requirements</h6>
                        <ol className="ml-4">
                            <li className="my-2">Application Letter</li>
                            <li className="my-2">Birth Certificate</li>
                            <li className="my-2">I.D</li>
                            <li className="my-2">O’ Level Certificate / Result slip </li>
                            <li className="my-2">NC Certificate / Transcript( for ND ENTRY)</li>
                            <li className="my-2">ND Certificate / Transcript( for HND ENTRY)</li>
                        </ol>
                        <motion.a 
                            href="/img/application-form.pdf"  
                            className="button grey-background mt-4 border-none" 
                            download
                            whileHover={{ scale: 1.06, originX: 'center'}}
                            transition={{ type: 'spring', stiffness: 600, damping: 3}}
                            
                        >
                            <span className="icon">
                                <AiOutlineDownload fontSize="1.2rem" color="white"/>
                            </span>
                            <span className="grey-text text-lighten-3">Application Form</span>
                        </motion.a><br/>
                        <motion.a 
                            href="/img/SC-Appliocation-Form.pdf"  
                            className="button grey-background mt-4 border-none" 
                            download
                            whileHover={{ scale: 1.06, originX: 'center'}}
                            transition={{ type: 'spring', stiffness: 600, damping: 3}}
                            
                        >
                            <span className="icon">
                                <AiOutlineDownload fontSize="1.2rem" color="white"/>
                            </span>
                            <span className="grey-text text-lighten-3">Application Form (Short Courses)</span>
                        </motion.a>
                    </div>
                </div>
                <div className="title mb-3 grey-text text-darken-3 mt-5 is-size-4">Online Application</div>
                <div className="application-cont">
                    <div>
                        <p className="grey-text text-darken-2">Online application allows to apply you to virtually submit your application for our admission attention.</p>
                        <motion.div
                            className="d-block"
                            whileHover={{ scale: 1.06}}
                            transition={{ type: 'spring', stiffness: 600, damping: 3}}
                        >
                            <Link to="online-application" className="button grey-background mt-5">
                                <span className="icon">
                                    <BsPencilSquare fontSize="1.2rem" color="white"/>
                                </span>
                                <span className="grey-text text-lighten-3">Online Application</span>
                            </Link>
                        </motion.div>
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default Hta;